import React from 'react'
import {
  Form,
  Input,
  Button,
  Select,
  TimePicker,
  message,
  Space,
  DatePicker,
  Tabs,
} from 'antd'
import { ProjectService, InformfixService } from '../../../services'
import TextArea from 'antd/lib/input/TextArea'
import { Moment } from '../../../helpers'
import { inject, observer } from 'mobx-react'
import { PlusCircleOutlined, ReloadOutlined } from '@ant-design/icons'
const { Option } = Select
const formatTime = 'HH:mm'
const TabPane = Tabs.TabPane

@inject('informStore')
@observer
class InformFormAdd extends React.Component {
  state = {
    homes: [],
    projects: [],
    loadingProject: false,
    loadingHome: false,
    loading: false,
    disabledSelectHome: true,
    home: {},
    project: {},
  }
  constructor() {
    super()
  }

  formRef = React.createRef()

  handleSubmit = (values) => {
    if (this.state.home) {
      this.setState({ loading: true })

      // ปรับเวลา timezone ให้ตรงก่อนส่งไปเก็บที่ server เนื่องจากค่่าที่เลือกับที่ส่งจากฟอร์มไม่ตรงกัน
      if (values.contact_time) {
        values.contact_time = Moment(values.contact_time)
          .utc(7)
          .format(formatTime)
      } else {
        values.contact_time = null
      }

      // ถ้าเวลาเป็น timestamp อยู่แล้วจากไม่ต้องปรับ  utc() ไม่งั้นเวลาจะไม่ตรง
      if (values.date_inform) {
        values.date_inform = Moment(values.date_inform).utc(7)
      }
      // ถ้าเวลาเป็น timestamp อยู่แล้วจากไม่ต้องปรับ  utc() ไม่งั้นเวลาจะไม่ตรง
      if (values.time_inform) {
        values.time_inform = Moment(values.time_inform).utc(7)
      }

      InformfixService.create(values)
        .then((rs) => {
          if (rs) {
            const data = rs.data.data
            this.setState({ loading: false })
            this.resetForm()
            this.props.informStore.setItem(data)

            //this.props.reload(data)
            this.props.onCreated(data)
            this.props.hideModal()
            console.log('new inform', data)
          }
        })
        .catch((err) => {
          this.setState({ loading: false })
        })
      // this.props.reload(data)
      // this.props.onCreated(data)
      // this.props.hideModal()
    } else {
      message.warning('ไม่มีข้อมูลบ้าน โปรดติดต่อเจ้าหน้าที่')
    }
  }

  resetForm() {
    this.formRef.current.resetFields()
  }

  componentDidMount() {
    this.getProjects()
  }

  getProjects = () => {
    this.setState({ loadingProject: true })
    this.setState({ homes: [] })
    ProjectService.all()
      .then((rs) => {
        if (rs) {
          let data = []
          rs.data['data'].map((item) => {
            let homes = []
            if (item.homeCustomer) {
              item.homeCustomer.map((home) => {
                homes.push({
                  value: home.id,
                  label:
                    'แปลง ' +
                    home.plan_no +
                    (home.home_no ? ' (เลขที่ ' + home.home_no + ')' : ''),
                })
              })
            }
            data.push({
              value: item.id,
              label: item.name,
              children: homes,
            })
          })
          this.setState({ loadingProject: false })
          this.setState({ projects: data, loading: false })
        }
      })
      .catch((err) => this.setState({ loadingHome: false }))
  }

  getHomeByProjectId = (projectId) => {
    this.setState({ disabledSelectHome: true, loadingHome: true })
    ProjectService.getHomesByProject(projectId)
      .then((rs) => {
        if (rs) {
          this.setState({ disabledSelectHome: false })
          this.setState({ homes: rs.data['data'], loading: false , loadingHome: false})
        }
      })
      .catch((err) => this.setState({ loadingHome: false, loading: false }))
  }

  onChangeProject = (value) => {
    this.formRef.current.setFieldsValue({
      home_id: null,
      customer_name: null
    })
    this.setState({ homes: [], home: {} })
    if (value) {
      this.setState({ homes: [], disabledSelectHome: true })
      this.getHomeByProjectId(value)
    }
  }

  handleOk = (e) => {
    console.log(e)
    this.setState({
      visible: false,
    })
  }

  handleCancel = (e) => {
    console.log(e)
    this.setState({
      visible: false,
    })
  }

  onSelectHome = (value) => {
    const { form } = this.props
    this.state.homes.map((home, index) => {
    
      if (home.id === value) {
        this.setState({
          home: home,
        })
        const name = this.state.homes[index].customer_name
        this.formRef.current.setFieldsValue({ 
          customer_name: name,
          home_id: home.id
         })
         console.log('home', home, name);
      }
    })
  }

  setInformerName = (name) => {
    this.formRef.current.setFieldsValue({
      informer: name
    })
  }

  render() {
    const {
      projects,
      homes,
      disabledSelectHome,
      loading,
      home,
      project,
    } = this.state
    const { form, modalOptions } = this.props
    const formLayout = 'horizontal'
    const formItemLayout =
      formLayout === 'horizontal'
        ? {
            labelCol: {
              xs: { span: 24 },
              sm: { span: 8 },
              md: { span: 8 },
            },
            wrapperCol: {
              xs: { span: 24 },
              sm: { span: 16 },
              md: { span: 16 },
            },
          }
        : null
    const buttonItemLayout =
      formLayout === 'horizontal'
        ? {
            wrapperCol: {
              xs: { span: 24, offset: 0 },
              sm: { span: 16, offset: 8 },
              md: { span: 16, offset: 8 },
            },
          }
        : null

    const listProjectItems = projects.map((item, index) => (
      <Option key={index} value={item.value}>
        {item.label}
      </Option>
    ))
    const listHomeItems = homes.map((item, index) => (
      <Option key={item.id} value={item.id}>
        {(item.homeType ? item.homeType.name : '') +
          (item.plan_no ? ' แปลง ' + item.plan_no : '') +
          (item.home_no ? ' (เลขที่ ' + item.home_no + ')' : '')}
      </Option>
    ))

    // แสดงวันที่
    const showFormatDate = (datetime) => {
      let date = Moment(datetime)
      if (date.isValid()) {
        return date.format('ll')
      } else {
        return null
      }
    }

    return (
      <React.Fragment>
        <Form
          {...formItemLayout}
          id="informfixForm"
          onFinish={this.handleSubmit}
          className=""
          ref={this.formRef}
          initialValues={{
            date_inform: Moment().utc(7),
          }}
        >
          {/* <Tabs defaultActiveKey="1" type="editable-card" size="small">
            <TabPane tab="ข้อมูลการแจ้งซ่อม" key="1"> */}
          <Form.Item
            label="เวลาที่ลูกค้าแจ้ง"
            {...formItemLayout}
            name="date_inform"
            rules={[{ required: true, message: 'เวลาที่ลูกค้าแจ้ง' }]}
          >
            <DatePicker
              inputReadOnly
              enderExtraFooter={() => 'โปรดระบุวันและเวลาที่ลูกค้าแจ้งเข้ามา'}
              showTime={{
                minuteStep: 15,
              }}
              ShowToday
              format="DD/MM/YYYY HH:mm"
              style={{ width: '100%' }}
            />
          </Form.Item>
          <Form.Item
            label="โครงการ"
            {...formItemLayout}
            name="project_id"
            rules={[{ required: true, message: 'เลือกโครงการ' }]}
          >
            <Select
              showSearch
              style={{}}
              placeholder="--เลือกโครงการ--"
              onChange={this.onChangeProject}
              allowClear
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {listProjectItems}
            </Select>
          </Form.Item>
          {!this.state.loadingHome ? (
            <>
                      <Form.Item
            label="บ้าน"
            {...formItemLayout}
            name="home_id"
            rules={[{ required: false, message: 'เลือกบ้าน' }]}
          >
            <Select
              showSearch
              allowClear
              disabled={disabledSelectHome}
              style={{}}
              placeholder="--ไม่ระบุ--"
              onChange={this.onSelectHome}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {listHomeItems}
            </Select>
            {home && home.transfer_date ? (
              <div style={{ padding: 5 }}>
                <div>
                  ผู้รับโอนกรรมสิทธิ์:{' '}
                  {home.customer_name
                    ? showFormatDate(home.customer_name)
                    : '-'}
                </div>
                <div>
                  วันที่โอน:{' '}
                  {home.transfer_date
                    ? showFormatDate(home.transfer_date)
                    : '-'}
                </div>
                {home && home.warrantyExpired ? (
                  <>
                    <div>
                      หมดรับประกัน 1 ปี:{' '}
                      {showFormatDate(home.warrantyExpired['1y'])}
                    </div>
                    <div>
                      หมดรับประกันโครงสร้าง (5 ปี):{' '}
                      {showFormatDate(home.warrantyExpired['5y'])}
                    </div>
                  </>
                ) : null}
              </div>
            ) : null}
          </Form.Item>
            </>
          ) : ''}
          <Form.Item
            label="ชื่อเจ้าของบ้าน"
            {...formItemLayout}
            name="customer_name"
            rules={[
              {
                required: false,
                message: 'ชื่อ - สกุล (ไม่ต้องใส่คำนำหน้า)',
              },
            ]}
          >
            <Input type="text" placeholder="ชื่อ - สกุล (ไม่ต้องใส่คำนำหน้า)" />
          </Form.Item>
          <Form.Item
            label="ผู้แจ้งซ่อม"
            {...formItemLayout}
            name="informer"
            rules={[{ required: true, message: 'กรุณากรอกชื่อผู้แจ้งซ่อม' }]}
          >
            <Input type="text" placeholder="ชื่อผู้แจ้งซ่อม" onDoubleClick={() => this.setInformerName('-')} /> 
          </Form.Item>
          <Form.Item
            label="เลือกเวลาเข้าตรวจสอบ"
            {...formItemLayout}
            name="contact_time"
            rules={[{ required: false, message: 'เวลาที่สะดวกให้เข้าตรวจสอบ' }]}
          >
            <TimePicker
              format={formatTime}
              minuteStep={15}
              secondStep={10}
              placeholder="เลือกเวลาเข้าตรวจสอบ"
            />
          </Form.Item>
          <Form.Item
            label="เบอร์โทร"
            {...formItemLayout}
            name="contact_phone"
            rules={[
              {
                required: false,
                message: 'เบอร์โทรสำหรับให้เจ้าหน้าที่ติดต่อกลับ',
              },
            ]}
          >
            <Input
              type="text"
              placeholder="เบอร์โทรสำหรับให้เจ้าหน้าที่ติดต่อกลับ"
            />
          </Form.Item>
          {/* <Form.Item
                label="หัวข้อ"
                {...formItemLayout}
                name="subject"
                rules={[{ required: true, message: 'กรุณากรอกหัวข้อ!' }]}
              >
                <Input placeholder="หัวข้อ" />
              </Form.Item> */}
          <Form.Item
            label="รายละเอียด"
            {...formItemLayout}
            name="description"
            rules={[
              {
                required: true,
                message: 'กรุณากรอกข้อความ และรายละเอียด!',
              },
            ]}
          >
            <TextArea rows={5} placeholder="รายละเอียด" />
          </Form.Item>
          <Form.Item {...buttonItemLayout}>
            <Button
              type="primary"
              htmlType="submit"
              className="submit"
              icon={<PlusCircleOutlined />}
            >
              บันทึก
            </Button>
            <Space />
            <Button
              type="light"
              htmlType="reset"
              className="submit"
              onClick={() => this.resetForm()}
              icon={<ReloadOutlined />}
            >
              รีเซ็ต
            </Button>
          </Form.Item>
          {/* </TabPane>
            <TabPane tab="งาน" key="2"></TabPane>
            <TabPane tab="รูปภาพ" key="3"></TabPane>
          </Tabs> */}
        </Form>
      </React.Fragment>
    )
  }
}

export default InformFormAdd
